// extracted by mini-css-extract-plugin
module.exports = {"THEME_NAME":"\"fixtercore\"","page":"cookie-policy_page__qxVXr"};